import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

const useSimilarSections = (oneCollectionData) => {
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtState, ["currentPath"], "");
const findSimilarSections = (similarData) => {
  if (!similarData || !currentPath) return null;
  const slug = currentPath.split('/').pop();
  for (const collectionItem of similarData.collection.items) {
      if (collectionItem.items) {
          // Filter items of type 'collection' at the first level
          const genreItems = collectionItem.items.filter((item) => item.type === 'collection');

          if (genreItems.length === 0) continue; // Skip if no collections

          for (const genreItem of genreItems) {

              if (genreItem.items) {
                  // Filter items of type 'collection' at the second level
                  const seriesItems = genreItem.items.filter((item) => item.type === 'collection');

                  if (seriesItems.length === 0) continue; // Skip if no collections

                  for (const seriesItem of seriesItems) {

                     /* if (seriesItem.slug.includes(slug) || slug.includes(seriesItem.slug)){
                          // Return filtered collection items excluding the matched one
                          return genreItem.slug;//seriesItems.filter((itms) => itms.slug !== seriesItem.slug);
                      }*/
                      if(seriesItem.items){
                        const seriesChildren = seriesItem.items.filter((item) => item.type === 'collection');
                        if(seriesChildren){
                            for(const child of seriesChildren){
                                if (child.slug.includes(slug) || slug.includes(child.slug)){
                                    return seriesItem.slug;//seriesItems.filter((itms) => itms.slug !== seriesItem.slug);
                                }
                            }
                        }
                      }
                      if (seriesItem.slug.includes(slug) || slug.includes(seriesItem.slug)){
                        // Return filtered collection items excluding the matched one
                        return genreItem.slug;//seriesItems.filter((itms) => itms.slug !== seriesItem.slug);
                    }
                  }
              }
          }
      }
  }

  return null;
};


 /*   const findSimilarSections = (similarData) => {
      if (!similarData || !currentPath) return null;
      const slug = currentPath.split('/').pop();
console.log("slugsss just",currentPath)
      for (const collectionItem of similarData.collection.items) {
          if (collectionItem.items) {
              for (const genreItem of collectionItem.items) {
                  if (genreItem.items) {
                      for (const seriesItem of genreItem.items) {
                          if (
                              seriesItem.slug.includes(slug) ||
                              slug.includes(seriesItem.slug)
                          ) {
                              return genreItem.items.filter(
                                  (itms) => itms.slug !== seriesItem.slug
                              );
                          }
                      }
                  }
              }
          }
      }
      return null;
  };*/
    const similarSectionParentSlug = useMemo(() => {
        if (oneCollectionData) {
            return findSimilarSections(oneCollectionData);
        }
        return null;
    }, [oneCollectionData, currentPath]);

    return [similarSectionParentSlug]//{ similarSections, loading, error };
};

export default useSimilarSections;
